<ion-header>
    <ion-toolbar class="ion-justify-content-center" color="primary">
        <ion-title>{{ title }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="modalCtrl.dismiss()">
                <ion-icon name="close" style="color: var(--ion-title-color);"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<div>
    <ion-grid aria-hidden="false">
        <ion-row>
            <ion-col>
                <formly-form [form]="form" [fields]="fields" [model]="myModel"></formly-form>
            </ion-col>
        </ion-row>
        <ion-row>
            <ion-col>
                <ion-grid>
                    <ion-row>
                        <ion-col size="12" size-md="4">
                            <ion-button (click)="modalCtrl.dismiss()" style="display: flex;" translate>
                                GENERAL.CANCEL
                            </ion-button>
                        </ion-col>
                        <ion-col size="12" size-md="8">
                            <ion-button style="display: flex;" [disabled]="!form.valid" (click)="onSelected()"
                                translate>
                                GENERAL.OK
                            </ion-button>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>
